import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	gap: 4px;
	align-items: center;
`;

export const CalendarIcon = styled.div<{ $isEnded?: boolean }>`
	width: 20px;
	height: 20px;
	svg {
		width: 100%;
		height: 100%;
		path {
			fill: ${({ theme, $isEnded }) => ($isEnded ? theme.colors.icon.chevron : theme.colors.control.primary)};
		}
		rect {
			fill: ${({ theme, $isEnded }) => ($isEnded ? theme.colors.icon.chevron : theme.colors.control.primary)};
		}
	}
`;

export const ClockIcon = styled.div`
	width: 20px;
	height: 20px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	svg {
		width: 100%;
		height: 100%;
		path {
			fill: ${({ theme }) => theme.colors.icon.deposit};
		}
	}
`;

export const Date = styled.div<{ $isSmall?: boolean }>`
	font-size: 18px;
	line-height: 25px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	${({ $isSmall }) =>
		$isSmall &&
		css`
			font-size: 16px;
			font-weight: 22px;
		`}

	@media (max-width: 992px) {
		font-size: 16px;
		font-weight: 22px;
	}
`;
